import React, { useState } from "react";
import { Button } from "primereact/button";
import { ListBox } from "primereact/listbox";
import EditSport from "./EditSport";
import { Dialog } from "primereact/dialog";

export default function SportsList({
  results,
  locked,
  setResults,
  sport,
  setsport,
  setEditSports,
}) {
  const [editVisible, setEditVisible] = useState(false);
  const [sportInEditIndex, setSportInEditIndex] = useState(null);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [removeIndex, setRemoveIndex] = useState(null);

  const onAddSport = () => {
    const newSport = {
      id: Date.now(), // use timestamp for unique id

      name: "",
      ascending: true,
      combined: false,
      time: false,
      directPoints: false,
      rounds: 1,
      tieBreakingRounds: 0,
      results: results.participants.map((p) => ({ id: p.id, results: [] })),
    };

    const newResults = {
      ...results,
      sports: [...results.sports, newSport],
    };

    setResults(newResults);
    setSportInEditIndex(newResults.sports.length - 1);
    setEditVisible(true);
  };

  const onRemoveSport = (index) => {
    const updatedSports = results.sports.filter((_, i) => i !== index);
    setResults({ ...results, sports: updatedSports });
  };

  const confirmRemoveSport = (index) => {
    setRemoveIndex(index);
    setConfirmVisible(true);
  };

  const sportTemplate = (sport) => {
    const index = results.sports.findIndex((s) => s.id === sport.id);

    console.log("sport:", sport, "index:", index);

    return (
      <div
        className="p-d-flex p-jc-between p-ai-center"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>
          {sport.completed && <i className="pi pi-check"></i>}{" "}
          {sport.name || <i>Nimetön</i>}
        </span>
        {!locked && (
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <Button
              icon="pi pi-pencil"
              className="p-button-outlined p-button-sm"
              onClick={(e) => {
                e.stopPropagation(); // prevent listbox selection on click
                setSportInEditIndex(index);
                setEditVisible(true);
              }}
            />
            <Button
              icon="pi pi-trash"
              className="p-button-outlined p-button-danger p-button-sm"
              onClick={(e) => {
                e.stopPropagation();
                confirmRemoveSport(index);
              }}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <ListBox
        value={sport}
        options={results.sports}
        optionLabel="name"
        itemTemplate={sportTemplate}
        emptyMessage="Ei lajeja"
        onChange={(e) => {
          const newIndex = results.sports.findIndex((s) => s.id === e.value.id);
          setsport(newIndex);
          setEditSports(false);
        }}
        style={{ width: "100%" }}
      />

      {!locked && (
        <Button
          label=""
          icon="pi pi-plus"
          className="mt-3 p-button-outlined"
          onClick={onAddSport}
          style={{ marginTop: "15px" }}
        />
      )}

      <EditSport
        editVisible={editVisible}
        setEditVisible={setEditVisible}
        results={results}
        setResults={setResults}
        sportInEditIndex={sportInEditIndex}
      />

      <Dialog
        visible={confirmVisible}
        onHide={() => setConfirmVisible(false)}
        dismissableMask
        header="Vahvista poisto"
        footer={
          <>
            <Button
              label="Poista"
              severity="danger"
              icon="pi pi-check"
              onClick={() => {
                onRemoveSport(removeIndex);
                setConfirmVisible(false);
              }}
            />
            <Button
              label="Peruuta"
              icon="pi pi-times"
              className="p-button-text"
              onClick={() => setConfirmVisible(false)}
            />
          </>
        }
      >
        Poistetaanko{" "}
        <b>{results.sports[removeIndex]?.name || <i>Nimetön</i>}</b>?<br />
        Kaikki tulokset poistetaan.
      </Dialog>
    </div>
  );
}
